// extracted by mini-css-extract-plugin
export default {"layout":"Index_layout__uplFg"};